import { getCoordinatorGroups } from './coordinator-queries';

const FETCH_COORDINATOR_GROUPS_FOR_NETWORK_REQUEST = 'FETCH_COORDINATOR_GROUPS_FOR_NETWORK_REQUEST';
const FETCH_COORDINATOR_GROUPS_FOR_NETWORK_SUCCESS = 'FETCH_COORDINATOR_GROUPS_FOR_NETWORK_SUCCESS';
const FETCH_COORDINATOR_GROUPS_FOR_NETWORK_ERROR = 'FETCH_COORDINATOR_GROUPS_FOR_NETWORK_ERROR';

const fetchCoordinatorGroupsForNetworkRequest = (network) => ({
  type: FETCH_COORDINATOR_GROUPS_FOR_NETWORK_REQUEST,
  payload: {
    network,
  },
});

const fetchCoordinatorGroupsForNetworkSuccess = (network, groups) => ({
  type: FETCH_COORDINATOR_GROUPS_FOR_NETWORK_SUCCESS,
  payload: {
    network,
    groups,
  },
});

const fetchCoordinatorGroupsForNetworkError = (network, error) => ({
  type: FETCH_COORDINATOR_GROUPS_FOR_NETWORK_ERROR,
  payload: {
    network,
    error,
  },
});

// thunk action for fetching coordinator groups
const fetchCoordinatorGroupsForNetwork = (network) => (dispatch, getState) => {
  dispatch(fetchCoordinatorGroupsForNetworkRequest(network));
  return getCoordinatorGroups(network).then((groups) => {
    dispatch(fetchCoordinatorGroupsForNetworkSuccess(network, groups));
  }).catch((error) => {
    dispatch(fetchCoordinatorGroupsForNetworkError(network, error));
  });
};

export {
  fetchCoordinatorGroupsForNetworkRequest,
  fetchCoordinatorGroupsForNetworkSuccess,
  fetchCoordinatorGroupsForNetworkError,
  FETCH_COORDINATOR_GROUPS_FOR_NETWORK_REQUEST,
  FETCH_COORDINATOR_GROUPS_FOR_NETWORK_SUCCESS,
  FETCH_COORDINATOR_GROUPS_FOR_NETWORK_ERROR,
  fetchCoordinatorGroupsForNetwork,
};
